<template>
  <div>
    <div class="xl:hidden absolute top-0 left-0 flex items-center gap-2 w-full" style="background: #fafafa" @click="$router.go(-1)">
      <img src="@/assets/icons/arrow_left_black.svg" />
      <h2 style="color: #3c3c3c">{{ getTitle }}</h2>
    </div>

    <component :is="getComponent" :comGroupList="comGroupList" />
  </div>
</template>

<script>
import ComparisonBarGraph from "@/components/ComparisonBarGraph";
import TableListPage from "@/views/list/TableListPage";
import BasicBarGraph from "@/components/BasicBarGraph";
import KPagination from "@/components/kPagination/kPagination";
import DateSelector from "@/components/selector/DateSelector";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";

export default {
  name: "Index",
  components: {
    SearchNavItemSelect,
    DateSelector,
    KPagination,
    BasicBarGraph,
    TableListPage,
    ComparisonBarGraph,
    GraphDetailNone: () => import("@/views/graph-detail/GraphDetailNone"),
    GraphDetail01: () => import("@/views/graph-detail/GraphDetail01"),
    GraphDetail02: () => import("@/views/graph-detail/GraphDetail02"),
    GraphDetail03: () => import("@/views/graph-detail/GraphDetail03"),
    GraphDetail04: () => import("@/views/graph-detail/GraphDetail04"),
    GraphDetail05: () => import("@/views/graph-detail/GraphDetail05"),
    GraphDetail06: () => import("@/views/graph-detail/GraphDetail06"),
    GraphDetail07: () => import("@/views/graph-detail/GraphDetail07"),
    GraphDetail08: () => import("@/views/graph-detail/GraphDetail08"),
    GraphDetail09: () => import("@/views/graph-detail/GraphDetail09"),
    GraphDetail10: () => import("@/views/graph-detail/GraphDetail10"),
    GraphDetail11: () => import("@/views/graph-detail/GraphDetail11"),
    GraphDetail12: () => import("@/views/graph-detail/GraphDetail12"),
    GraphDetail13: () => import("@/views/graph-detail/GraphDetail13"),
    GraphDetail14: () => import("@/views/graph-detail/GraphDetail14"),
    GraphDetail15: () => import("@/views/graph-detail/GraphDetail15"),
    GraphDetail16: () => import("@/views/graph-detail/GraphDetail16"),
    GraphDetail17: () => import("@/views/graph-detail/GraphDetail17"),
    GraphDetail18: () => import("@/views/graph-detail/GraphDetail18"),
    GraphDetail19: () => import("@/views/graph-detail/GraphDetail19"),
    GraphDetail20: () => import("@/views/graph-detail/GraphDetail20"),
    GraphDetail21: () => import("@/views/graph-detail/GraphDetail21"),
    GraphDetail22: () => import("@/views/graph-detail/GraphDetail22"),
    GraphDetail23: () => import("@/views/graph-detail/GraphDetail23"),
    GraphDetail24: () => import("@/views/graph-detail/GraphDetail24"),
    GraphDetail25: () => import("@/views/graph-detail/GraphDetail25"),
    GraphDetail26: () => import("@/views/graph-detail/GraphDetail26"),
    GraphDetail27: () => import("@/views/graph-detail/GraphDetail27"),
    GraphDetail28: () => import("@/views/graph-detail/GraphDetail28"),
    GraphDetail29: () => import("@/views/graph-detail/GraphDetail29"),
    GraphDetail30: () => import("@/views/graph-detail/GraphDetail30"),
    GraphDetail31: () => import("@/views/graph-detail/GraphDetail31"),
    GraphDetail32: () => import("@/views/graph-detail/GraphDetail32"),
    GraphDetail33: () => import("@/views/graph-detail/GraphDetail33"),
    GraphDetail34: () => import("@/views/graph-detail/GraphDetail34"),
    GraphDetail35: () => import("@/views/graph-detail/GraphDetail35"),
    GraphDetail36: () => import("@/views/graph-detail/GraphDetail36"),
    GraphDetail42: () => import("@/views/graph-detail/GraphDetail42"),
    GraphDetail43: () => import("@/views/graph-detail/GraphDetail43"),
    GraphDetail44: () => import("@/views/graph-detail/GraphDetail44"),
    GraphDetail45: () => import("@/views/graph-detail/GraphDetail45"),
    GraphDetail46: () => import("@/views/graph-detail/GraphDetail46"),
    GraphDetail47: () => import("@/views/graph-detail/GraphDetail47"),
    GraphDetail48: () => import("@/views/graph-detail/GraphDetail48"),
    GraphDetail49: () => import("@/views/graph-detail/GraphDetail49"),
    GraphDetail50: () => import("@/views/graph-detail/GraphDetail50"),
    GraphDetail51: () => import("@/views/graph-detail/GraphDetail51"),
    GraphDetail52: () => import("@/views/graph-detail/GraphDetail52"),
    GraphDetail53: () => import("@/views/graph-detail/GraphDetail53"),
    GraphDetail54: () => import("@/views/graph-detail/GraphDetail54"),
    GraphDetail55: () => import("@/views/graph-detail/GraphDetail55"),
    GraphDetail56: () => import("@/views/graph-detail/GraphDetail56"),
    GraphDetail57: () => import("@/views/graph-detail/GraphDetail57"),
    GraphDetail58: () => import("@/views/graph-detail/GraphDetail58"),
    GraphDetail59: () => import("@/views/graph-detail/GraphDetail59"),
    GraphDetail60: () => import("@/views/graph-detail/GraphDetail60"),
    GraphDetail61: () => import("@/views/graph-detail/GraphDetail61"),
    GraphDetail62: () => import("@/views/graph-detail/GraphDetail62"),
    GraphDetail63: () => import("@/views/graph-detail/GraphDetail63"),
    GraphDetail64: () => import("@/views/graph-detail/GraphDetail64"),
    GraphDetail65: () => import("@/views/graph-detail/GraphDetail65"),
    GraphDetail66: () => import("@/views/graph-detail/GraphDetail66"),
    GraphDetail67: () => import("@/views/graph-detail/GraphDetail67"),
    GraphDetail68: () => import("@/views/graph-detail/GraphDetail68"),
    GraphDetail69: () => import("@/views/graph-detail/GraphDetail69"),
    GraphDetail70: () => import("@/views/graph-detail/GraphDetail70"),
    GraphDetail71: () => import("@/views/graph-detail/GraphDetail71"),
    GraphDetail72: () => import("@/views/graph-detail/GraphDetail72"),
    GraphDetail73: () => import("@/views/graph-detail/GraphDetail73"),
    GraphDetail74: () => import("@/views/graph-detail/GraphDetail74"),
    GraphDetail75: () => import("@/views/graph-detail/GraphDetail75"),
    GraphDetail76: () => import("@/views/graph-detail/GraphDetail76"),
    GraphDetail77: () => import("@/views/graph-detail/GraphDetail77"),
    GraphDetail78: () => import("@/views/graph-detail/GraphDetail78"),
    GraphDetail79: () => import("@/views/graph-detail/GraphDetail79"),
    GraphDetail80: () => import("@/views/graph-detail/GraphDetail80"),
    GraphDetail81: () => import("@/views/graph-detail/GraphDetail81"),
    GraphDetail82: () => import("@/views/graph-detail/GraphDetail82"),
    GraphDetail83: () => import("@/views/graph-detail/GraphDetail83"),
    GraphDetail84: () => import("@/views/graph-detail/GraphDetail84"),
    GraphDetail85: () => import("@/views/graph-detail/GraphDetail85"),
    GraphDetail86: () => import("@/views/graph-detail/GraphDetail86"),
    GraphDetail87: () => import("@/views/graph-detail/GraphDetail87"),
    GraphDetail88: () => import("@/views/graph-detail/GraphDetail88"),
    GraphDetail89: () => import("@/views/graph-detail/GraphDetail89"),
  },
  data() {
    return {};
  },
  async created() {
    await this.loadCompanyList();
  },
  async mounted() {},
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    getTitle() {
      const nId = Number(`${this.graphId}`);
      const projectId = Number(this.projectId);
      switch (nId) {
      case 1:
        return "사업장 현황";
      case 2:
        return "종사자 현황";
      case 3:
        return "산업안전보건위원회 구성 현황";
      case 4:
        return "노사협의체 구성 현황";
      case 5:
        return "안전보건 예산 현황";
      case 6:
        return "안전보건 교육";
      case 7:
        return "종사자 의견 청취 현황";
      case 8:
        return "유해·위험요인 조사 현황";
      case 9:
        return "정기 위험성평가 현황";
      case 10:
        return "수시 위험성평가 현황";
      case 11:
        return "작업장 합동점검 현황";
      case 12:
        return "안전보건 점검 현황";
      case 13:
        return "비상대피 훈련 현황";
      case 14:
        return "중대재해 발생 현황";
      case 15:
        return "안전보건 예산 집행률 현황";
      case 16:
        return "시설물 점검 현황";
      case 17:
        return "시설물 진단 현황";
      case 18:
        return "시설물 보수 현황";
      case 19:
        return "시설물 보강 현황";
      case 20:
        return "시설물 교체 현황";
      case 21:
        return "원료·제조물 사업장";
      case 22:
        return "시설물 안전계획 현황";
      case 23:
        if (projectId === 5) return "(시설물) 안전·보건 예산 현황";
        else return "시설물 안전예산 현황";
      case 24:
        if (projectId === 5) return "(원료·제조물 사업장) 안전·보건 예산 현황";
        else return "원료·제조물 사업장 안전예산 현황";
      case 25:
        return "시설물 예산 집행률 현황";
      case 26:
        return "원료·제조물 사업장 예산 집행률 현황";
      case 27:
        return "시설물 보수·보강 현황";
      case 28:
        return "(시설물) 유해·위험요인 점검 현황";
      case 29:
        return "(시설물) 유해·위험요인 개선 현황";
      case 30:
        return "(사업장) 유해·위험요인 점검 현황";
      case 31:
        return "(사업장) 유해·위험요인 개선 현황";
      case 32:
        if (projectId === 5) return "(원료·제조물 사업장) 안전·보건 예산 현황";
        else return "원료·제조물 사업장 안전예산 현황";
      case 33:
        return "원료·제조물 사업장 안전예산 집행률 현황";
      case 34:
        return "안전계획 현황";
      case 42:
        return "공중(다중)이용시설 안전·보건 예산 집행률 현황";
      case 43:
        return "공중교통수단 안전·보건 예산 집행률 현황";
      default:
        return "";
      }
    },
    getComponent() {
      let nId = 0;
      try {
        nId = Number(`${this.graphId}`);
      } catch (e) {
        nId = 0;
      }

      if (nId > 0) {
        const id = nId >= 10 ? nId : `0${nId}`;
        return `GraphDetail${id}`;
      } else {
        return "GraphDetailNone";
      }
    },
    comGroupList() {
      const companyTree = this.$store.state.company.companyTree;
      let maxDepth = 0;
      const list = {};
      let hasRootHead = false;
      const headList = [];

      if (companyTree.length > 0) {
        for (const com of companyTree) {
          if (!com || !com.descendant) {
            continue;
          }

          if (typeof com.descendant !== "undefined" && com.descendant.com_type === "head") {
            hasRootHead = true;
            headList.push(com.descendant.com_name);
          }
          if (com.depth > maxDepth) {
            maxDepth = com.depth;
          }

          const parentId = com.descendant.parent_id ? com.descendant.parent_id : com.descendant.id;
          //const com_name =
          if (list[`com_${parentId}`]) {
            list[`com_${parentId}`][com.descendant.id] = com.descendant.com_name;
          } else {
            list[`com_${parentId}`] = { [com.descendant.id]: com.descendant.com_name };
          }
        }
      }

      return {
        maxDepth,
        hasRootHead,
        headList,
        list,
      };
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    projectList() {
      const list = this.$store.state.project.projectListInfo.data;
      const projectList = [];
      if (list && list.length > 0) {
        for (const proj of list) {
          projectList.push(proj.field_name);
        }
      }
      return projectList;
    },
  },
  methods: {
    async loadCompanyList() {
      const page = 1;
      const perPage = 10000;
      const projectId = this.projectId;
      await this.$store.dispatch("company/LOAD_COMPANY_TREE", { projectId });
      await this.$store.dispatch("company/LOAD_COMPANY_LIST", {
        page,
        perPage,
        comType: "head",
        projectId,
      });
    },
  },
};
</script>

<style lang="scss">
[dir] .vx-card.graph2 .vx-card__collapsible-content .vx-card__body {
  padding: 0 0 1.5rem 0;
}
</style>
